import { useState, useEffect } from 'react';

import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import { api } from './utils';
import { getTenant } from './helpers';



const useResume = ( username ) => {
    const [resume, setResume] = useState(null);
    const [resumeDataLoaded, setResumeDataLoaded] = useState(false);

    const getResumeFromData = (data) => {
        if (!Array.isArray(data.files) || !data.files) {
            return '';
        }
        const resumeFile = data.files.find(file => file.type === 'resume');
        return resumeFile
            ? resumeFile.url
            : null;


    }

    useEffect(() => {
        const DEFAULT_TENANT_TO_USE = process.env.REACT_APP_IBL_PROFILE_RESUME_FEATURE_TENANT_TO_USE_WITH_ENDPOINTS ?? getTenant()
        api.ibldmplatform.getUserResume(
            { org: DEFAULT_TENANT_TO_USE, userID: username },
            (data) => {
                setResume(getResumeFromData(data));
                setResumeDataLoaded(true);
            },
            (error) => {
                setResume(null);
                setResumeDataLoaded(true);
            }
        );
    }, []);

    return { resume, resumeDataLoaded };
};

export default useResume;
